<template>

<app-content :loading="is.loading && !is.initialised">

	<app-content-head title="Browse" subtitle="See which games have been checked out by badge holders.">

		<app-content-head-actions-panel v-if="collection.length" text="Export" icon="export" component="manager/common/panel/Export" :data="importexportData" />
		
		<app-content-head-actions-item v-if="$authorised('con/checkout/access', 'write') && hasActive" text="Returned" icon="returned" :disabled="!selected.length" v-on:click="onReturnClick" />

	</app-content-head>

	<app-content-filters :changed="isFilterDirty" v-on:reset="onResetFilter">

		<app-content-filters-search v-model="filter.search" />

		<app-content-filters-date mode="datetime" v-model="filter.from" tooltip="Filter from date" text="From" :max="filter.to" />

		<app-content-filters-date mode="datetime" v-model="filter.to" tooltip="Filter to date" text="To" :min="filter.from" />

		<app-content-filters-tags v-model="filter.tags" :options="filterTags" />
		
		<app-content-filters-select v-model="filter.playtowins" text="Play to Wins" tooltip="Filter Play to Wins" :options="$util.options(winOptions)" />
		
		<app-content-filters-select v-model="filter.sort" text="Sort by" prefix="Sort by" tooltip="Change sorting" :options="$util.options(filterSorts)" />

	</app-content-filters>

	<app-content-body :loading="is.loading && is.initialised" :is-empty="!collection.length" placeholder="Sorry, no loans found.">

		<app-table>

			<app-table-head :layout="layout">

				<app-table-column />
				
				<app-table-column text="Ref" />
				
				<app-table-column text="Game" />
				
				<app-table-column text="Badge" :indent="true" />
				
				<app-table-column border="left" :sorted="filter.sort === 'hours'" align="center" text="Hours" />
				
				<app-table-column align="center" text="Players" />
				
				<app-table-column border="left" :sorted="filter.sort === 'date.out'" text="Checked Out" />
				
				<app-table-column border="right" :sorted="filter.sort === 'date.in'" text="Checked In" />
				
				<app-table-column />

			</app-table-head>

			<app-table-body>

				<app-table-row v-on:click="onEditClick(item.id)" :selected="isSelected(item.id)" :layout="layout" v-for="item in collection" :key="item.id">

					<app-table-cell-label :text="$constants.checkout.loan.tagName[item.statusReturn]" :type="$constants.checkout.loan.tagTheme[item.statusReturn]" />
					
					<app-table-cell-text :text="item.reference" />

					<app-table-cell-game :game="item.game" />

					<app-table-cell-badge :badge="item.badge" />
					
					<app-table-cell-text border="left" align="center" :text="item.hours" />

					<app-table-cell-text align="center" :text="item.players" />
					
					<app-table-cell-text border="left" :text="item.date.out | localDate('h:mma')" :subtext="item.date.out | localDate('dddd')" />
					
					<app-table-cell-text border="right" :can-empty="true" :text="item.date.in | localDate('h:mma')" :subtext="item.date.in | localDate('dddd')" />
					
					<app-table-cell-select :active="isSelected(item.id)" v-on:click="onSelectToggle(item.id)" v-if="item.statusReturn !== $constants.checkout.loan.tag.returned" />

				</app-table-row>

			</app-table-body>

			<app-table-foot :pagination="pagination" :total="total" />

		</app-table>

	</app-content-body>

</app-content>

</template>

<script>

import mixCollection from '@/mixin/collection'

export default {

	mixins: [mixCollection],

	data: function() {

		return {
			references: {
				sorts: [],
				tags: []
			},
			filter: {
				tags: [],
				from: 0,
				to: 0,
				playtowins: 'any',
				sort: 'date.out'
			},
			layout: '80px 48px minmax(0, 1fr) minmax(0, 1fr) 80px 80px 120px 120px 24px',
			endpoint: 'convention/checkout/loans',
			live: 'convention/checkout/loans',
			edit: 'Convention.Checkout.Loans.Edit',
			winOptions: {
				'any': 'Any game',
				'only': 'Only Play to Wins',
				'none': 'Exclude Play to Wins'
			},
			filterSorts: {
				'date.out': 'Checked Out',
				'date.in': 'Checked In',
				'hours': 'Hours'
			}
		}

	},

	computed: {

		hasActive: function() {
		
			return this.$_.findWhere(this.collection, {
				status: this.$constants.checkout.loan.status.active
			})

		},

		filterTags: function() {
		
			return [
				{ value: 1, text: 'Active', theme: 'blue' },
				{ value: 2, text: 'Overdue', theme: 'red', hidden: !this.hasLimit },
				{ value: 3, text: 'Returned', theme: 'green' }
			]
		
		},

		hasLimit: function() {

			return this.$settings.checkout.limit.hours.enabled

		},
		
		importexportData: function() {

			return {
				columns: {
					'reference': 'Reference',
					'statusReturn': 'Status',
					'gameReference': 'Game Reference',
					'gameName': 'Game Name',
					'gameVersion': 'Game Version',
					'badgeReference': 'Badge Reference',
					'badgeName': 'Badge Name',
					'dateOut': 'Checked Out Date',
					'dateIn': 'Checked Out Date',
					'hours': 'Hours Loaned',
					'players': 'Players Scanned'
				},
				requiredColumns: [],
				valueMapping: {},
				params: this.getParams(),
				index: this.selectedIndex,
				endpoint: this.endpoint
			}

		}

	},

	methods: {

		onReturnClick: function() {

			this.$api.patch(this.endpoint, {
				index: this.selected,
				model: {
					status: this.$constants.checkout.loan.status.returned
				}
			}).then(function() {

				this.selected = []

			}.bind(this))

		}

	}

}

</script>

<style scoped>

</style>